import { createReducer, on } from '@ngrx/store'
import { GeneralMapActions } from './action-types'
import { CurrentFeatureInfoInterface } from '../interfaces/current-feature-info.interface'
import cloneDeep from 'lodash/cloneDeep'
import { IMapStateParcelToGroupDrawing } from '../../../../../features/map/interfaces/map-state.interface'
import { MapInfoBoxTypeEnum } from '../../../../../features/map/info-box/map-info-box-type.enum'
import { MapInfoBoxTypeSetup } from '../../../../../features/map/info-box/map-info-box-type.setup'
import { has, set } from 'lodash'

const INIT_STATE: IGeneralMapState = {
    backlink: false,
    pagePrintHeading: null,
    padding: null,
    detailFeature: null,
    currentFeatureInfo: null,
    features: [], // must be array all the time!
    header: null,
    parcelToGroupDrawing: {
        drawInfoboxDrawingState: null,
        drawInfoboxPolygonValid: true,
        allParcelsLayerVisible: null,
        drawInfoboxDrawingCoordinatesLength: null,
        // SPLIT
        splitInfoboxState: null,
    },
    measuredLength: 0,
    measuredArea: 0,
    measuredCoordinates: 0,
    parcelListShowAddonInformation: false,
    layersConfig: {},
    layersOutsideSelector: [], // must be array all the time!
    parcelContractEndingDate: null,
    parcelContractEndingDateVisible: false,
    parcelContractEndingDateMinimalized: false,
    saveLayersVisibility: false,
    saveLayersVisibilityAfterInit: false,
    storagePrefix: null,
    zoomedId: {
        featureId: null,
        layerName: null,
    },
    showedInfoBox: null,
    showedLpisUserSelection: false,
    showedLpisEndingContract: false,
    showedParcelSelectByShapeDrawing: false,
    showedParcelSelectByAddArea: false,
    showedParcelSplitting: false,
    collapsed: false,
    lpisUserSelectionCollapsed: false,
    lpisEndingContractCollapsed: false,
    parcelSelectByShapeDrawingCollapsed: false,
    parcelSelectByAddAreaCollapsed: false,
    parcelSplittingCollapsed: false,
    showedLpisUserSelectionCollapsed: false,
}

export const generalMapReducer = createReducer(
    {},
    on(GeneralMapActions.initMap, (state, {mapId}): Record<string, IGeneralMapState> => (
        state[mapId] ? state : {...state, [mapId]: {...INIT_STATE} }
    )),
    // on(GeneralMapActions.setMap, (state, {mapId, map}): Record<string, IGeneralMapState> => (
    //     ({...state, [mapId]: {...state[mapId], map: map } })
    // )),
    on(GeneralMapActions.resetMap, (state, {mapId}): Record<string, IGeneralMapState> => {
        const newState = cloneDeep(state)
        delete newState[mapId]
        return newState
    }),
    on(GeneralMapActions.setBacklink, (state, {mapId, backlink}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], backlink: backlink } })
    ),
    on(GeneralMapActions.setMapSimplePagePrintHeading, (state, {mapId, heading}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], pagePrintHeading: heading } })
    ),
    on(GeneralMapActions.setMapSimpleCurrentFeatureInfo, (state, {mapId, info}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], currentFeatureInfo: info } })
    ),
    on(GeneralMapActions.resetMapSimpleCurrentFeatureInfo, (state, {mapId}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], currentFeatureInfo: INIT_STATE.currentFeatureInfo } })
    ),
    on(GeneralMapActions.setMapSimpleDetailFeature, (state, {mapId, feature}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], detailFeature: feature } })
    ),
    on(GeneralMapActions.resetMapSimpleDetailFeature, (state, {mapId}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], detailFeature: INIT_STATE.detailFeature } })
    ),
    on(GeneralMapActions.setMapSimpleFeatures, (state, {mapId, features}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], features: features } })
    ),
    on(GeneralMapActions.setHeader, (state, {mapId, value}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], header: value } })
    ),
    on(GeneralMapActions.setMapMeasuredLength, (state, {mapId, measuredLength}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], measuredLength: measuredLength } })
    ),
    on(GeneralMapActions.resetMapMeasuredLength, (state, {mapId}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], measuredLength: INIT_STATE.measuredLength } })
    ),
    on(GeneralMapActions.setMapMeasuredArea, (state, {mapId, measuredArea}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], measuredArea: measuredArea } })
    ),
    on(GeneralMapActions.resetMapMeasuredArea, (state, {mapId}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], measuredArea: INIT_STATE.measuredArea } })
    ),
    on(GeneralMapActions.setMapMeasuredCoordinates, (state, {mapId, measuredCoordinates}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], measuredCoordinates: measuredCoordinates } })
    ),
    on(GeneralMapActions.resetMapSimpleMapMeasuredCoordinates, (state, {mapId}): Record<string, IGeneralMapState> =>
       ({...state, [mapId]: {...state[mapId], measuredCoordinates: INIT_STATE.measuredCoordinates } })
    ),
    on(GeneralMapActions.setMapDrawingBoxDrawState, (state, {mapId, drawingState}): Record<string, IGeneralMapState> => {
        const updatedParcelToGroupDrawing = cloneDeep(state[mapId].parcelToGroupDrawing)
        updatedParcelToGroupDrawing.drawInfoboxDrawingState = drawingState
        return {...state, [mapId]: {...state[mapId], parcelToGroupDrawing: updatedParcelToGroupDrawing}}
    }),
    on(GeneralMapActions.resetMapDrawingBoxDrawState, (state, {mapId}): Record<string, IGeneralMapState> => {
        const updatedParcelToGroupDrawing = cloneDeep(state[mapId].parcelToGroupDrawing)
        updatedParcelToGroupDrawing.drawInfoboxDrawingState = INIT_STATE.parcelToGroupDrawing.drawInfoboxDrawingState
        return {...state, [mapId]: {...state[mapId], parcelToGroupDrawing: updatedParcelToGroupDrawing}}
    }),
    on(GeneralMapActions.setMapSplitBoxState, (state, {mapId, splitInfoboxState}): Record<string, IGeneralMapState> => {
        const updatedParcelToGroupDrawing = cloneDeep(state[mapId].parcelToGroupDrawing)
        updatedParcelToGroupDrawing.splitInfoboxState = splitInfoboxState
        return {...state, [mapId]: {...state[mapId], parcelToGroupDrawing: updatedParcelToGroupDrawing}}
    }),
    on(GeneralMapActions.setMapDrawingBoxPolygonValid, (state, {mapId, value}): Record<string, IGeneralMapState> => {
        const updatedParcelToGroupDrawing = cloneDeep(state[mapId].parcelToGroupDrawing)
        updatedParcelToGroupDrawing.drawInfoboxPolygonValid = value
        return {...state, [mapId]: {...state[mapId], parcelToGroupDrawing: updatedParcelToGroupDrawing}}
    }),
    on(GeneralMapActions.setAllParcelsLayerVisible, (state, {mapId, value}): Record<string, IGeneralMapState> => {
        const updatedParcelToGroupDrawing = cloneDeep(state[mapId].parcelToGroupDrawing)
        updatedParcelToGroupDrawing.allParcelsLayerVisible = value
        return {...state, [mapId]: {...state[mapId], parcelToGroupDrawing: updatedParcelToGroupDrawing}}
    }),
    on(GeneralMapActions.setMapDrawingBoxDrawCoordinatesLength, (state, {mapId, value}): Record<string, IGeneralMapState> => {
        const updatedParcelToGroupDrawing = cloneDeep(state[mapId].parcelToGroupDrawing)
        updatedParcelToGroupDrawing.drawInfoboxDrawingCoordinatesLength = value
        return {...state, [mapId]: {...state[mapId], parcelToGroupDrawing: updatedParcelToGroupDrawing}}
    }),
    on(GeneralMapActions.resetMapDrawingBoxDrawCoordinatesLength, (state, {mapId}): Record<string, IGeneralMapState> => {
        const updatedParcelToGroupDrawing = cloneDeep(state[mapId].parcelToGroupDrawing)
        updatedParcelToGroupDrawing.drawInfoboxDrawingCoordinatesLength = INIT_STATE.parcelToGroupDrawing.drawInfoboxDrawingCoordinatesLength
        return {...state, [mapId]: {...state[mapId], parcelToGroupDrawing: updatedParcelToGroupDrawing}}
    }),
    on(GeneralMapActions.resetMapDrawing, (state, {mapId, fullReset}): Record<string, IGeneralMapState> => {
        const updatedParcelToGroupDrawing = cloneDeep(state[mapId].parcelToGroupDrawing)
        updatedParcelToGroupDrawing.drawInfoboxDrawingState = INIT_STATE.parcelToGroupDrawing.drawInfoboxDrawingState
        updatedParcelToGroupDrawing.drawInfoboxPolygonValid = INIT_STATE.parcelToGroupDrawing.drawInfoboxPolygonValid
        updatedParcelToGroupDrawing.drawInfoboxDrawingCoordinatesLength = INIT_STATE.parcelToGroupDrawing.drawInfoboxDrawingCoordinatesLength
        if (fullReset) {
            updatedParcelToGroupDrawing.allParcelsLayerVisible = INIT_STATE.parcelToGroupDrawing.allParcelsLayerVisible
        }
        return {...state, [mapId]: {...state[mapId], parcelToGroupDrawing: updatedParcelToGroupDrawing}}
    }),
    on(GeneralMapActions.resetMapSplitting, (state, {mapId}): Record<string, IGeneralMapState> => {
        const updatedParcelToGroupDrawing = cloneDeep(state[mapId].parcelToGroupDrawing)
        updatedParcelToGroupDrawing.splitInfoboxState = INIT_STATE.parcelToGroupDrawing.splitInfoboxState
        return {...state, [mapId]: {...state[mapId], parcelToGroupDrawing: updatedParcelToGroupDrawing}}
    }),
    on(GeneralMapActions.setMapSimpleMapParcelListShowAddonInformation, (state, {mapId, value}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], parcelListShowAddonInformation: value } })
    ),
    on(GeneralMapActions.setLayersConfig, (state, {mapId, config}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], layersConfig: config } })
    ),
    on(GeneralMapActions.resetMapSimpleLayersConfig, (state, {mapId}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], layersConfig: INIT_STATE.layersConfig } })
    ),
    on(GeneralMapActions.setMapSimpleLayersOutsideSelector, (state, {mapId, selector}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], layersOutsideSelector: selector } })
    ),
    on(GeneralMapActions.resetMapSimpleLayersOutsideSelector, (state, {mapId}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], layersOutsideSelector: INIT_STATE.layersOutsideSelector } })
    ),
    on(GeneralMapActions.setPadding, (state, {mapId, padding}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], padding: padding } })
    ),
    on(GeneralMapActions.resetMapSimplePadding, (state, {mapId}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], padding: INIT_STATE.padding } })
    ),
    on(GeneralMapActions.setMapSimpleParcelContractEndingDate, (state, {mapId, date}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], parcelContractEndingDate: date } })
    ),
    on(GeneralMapActions.setParcelContractEndingDate, (state, {mapId, expDate}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], parcelContractEndingDate: expDate } })
    ),
    on(GeneralMapActions.setMapSimpleParcelContractEndingDateVisible, (state, {mapId, value}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], parcelContractEndingDateVisible: value } })
    ),
    on(GeneralMapActions.setMapSimpleParcelContractEndingDateMinimalized, (state, {mapId, value}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], parcelContractEndingDateMinimalized: value } })
    ),
    on(GeneralMapActions.setMapSimpleSaveLayersVisibility, (state, {mapId, value}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], saveLayersVisibility: value } })
    ),
    on(GeneralMapActions.setMapSimpleSaveLayersVisibilityAfterInit, (state, {mapId, value}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], saveLayersVisibilityAfterInit: value } })
    ),
    on(GeneralMapActions.enableMapSimpleSaveLayersVisibility, (state, {mapId}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], saveLayersVisibility: state[mapId].saveLayersVisibilityAfterInit } })
    ),
    on(GeneralMapActions.setMapSimpleStoragePrefix, (state, {mapId, prefix}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], storagePrefix: prefix } })
    ),
    on(GeneralMapActions.setMapSimpleZoomedId, (state, {mapId, zoomedId}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], zoomedId: zoomedId } })
    ),
    on(GeneralMapActions.resetMapSimpleZoomedId, (state, {mapId}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], zoomedId: INIT_STATE.zoomedId } })
    ),
    on(GeneralMapActions.setMapInfoBox, (state, {mapId, showedInfoBox}): Record<string, IGeneralMapState> => (
        showedInfoBox < MapInfoBoxTypeEnum.lpisUserSelection ?
            {...state, [mapId]: {...state[mapId], showedInfoBox: showedInfoBox }} :
            {...state, [mapId]: {...state[mapId], [MapInfoBoxTypeSetup[showedInfoBox]?.propertyKey]: showedInfoBox}}
    )),
    on(GeneralMapActions.resetMapInfoBox, (state, {mapId, showedInfoBox}): Record<string, IGeneralMapState> => (
        showedInfoBox < MapInfoBoxTypeEnum.lpisUserSelection ?
            {...state, [mapId]: {...state[mapId], showedInfoBox: null }} :
            {...state, [mapId]: {...state[mapId], [MapInfoBoxTypeSetup[showedInfoBox]?.propertyKey]: null}}
    )),
    on(GeneralMapActions.toggleMapInfoBox, (state, {mapId, showedInfoBox}): Record<string, IGeneralMapState> => {
        const newMapIdState = cloneDeep(state[mapId])
        if (showedInfoBox < MapInfoBoxTypeEnum.lpisUserSelection) {
            newMapIdState.collapsed = !state[mapId].collapsed
        } else if (showedInfoBox === MapInfoBoxTypeEnum.lpisUserSelection) {
            newMapIdState.lpisUserSelectionCollapsed = !state[mapId].lpisUserSelectionCollapsed
        } else if (showedInfoBox === MapInfoBoxTypeEnum.lpisEndingContract) {
            newMapIdState.lpisEndingContractCollapsed = !state[mapId].lpisEndingContractCollapsed
        } else if (showedInfoBox === MapInfoBoxTypeEnum.parcelSelectByShapeDrawing) {
            newMapIdState.parcelSelectByShapeDrawingCollapsed = !state[mapId].parcelSelectByShapeDrawingCollapsed
        } else if (showedInfoBox === MapInfoBoxTypeEnum.parcelSelectByAddArea) {
            newMapIdState.parcelSelectByAddAreaCollapsed = !state[mapId].parcelSelectByAddAreaCollapsed
        } else if (showedInfoBox === MapInfoBoxTypeEnum.parcelSplitting) {
            newMapIdState.parcelSplittingCollapsed = !state[mapId].parcelSplittingCollapsed
        }
        return {...state, [mapId]: newMapIdState}
    }),
    on(GeneralMapActions.setMapSimpleShowedLpisUserSelectionCollapsed, (state, {mapId, collapsed}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], showedLpisUserSelectionCollapsed: collapsed } })
    ),
    on(GeneralMapActions.setMapSimpleLayersConfigPropertyByLayerId, (state, {mapId, layerId, property, value}): Record<string, IGeneralMapState> => {
        const newState = cloneDeep(state)
        if (newState[mapId]?.layersConfig?.id === layerId) {
            set(newState[mapId].layersConfig, [property], value)
        } else {
            newState[mapId].layersConfig.layers.forEach( (group, indexGroup) => {
                if (group.id === layerId) {
                    set(newState[mapId].layersConfig, ['layers', indexGroup, property], value)
                }
                if(has(group, 'layers') && group.layers?.length) {
                    group.layers.forEach((layer, indexLayer) => {
                        if (layer.id === layerId) {
                            set(newState[mapId].layersConfig, ['layers', indexGroup, 'layers', indexLayer, property], value)
                        }
                    })
                }
            })
        }
        return newState
    }),
    on(GeneralMapActions.setupLpisDetail, (state, {mapId, feature}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], detailFeature: feature, backlink: false } })
    ),
    on(GeneralMapActions.setupParcelDetail, (state, {mapId, feature, backlink}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], detailFeature: feature, backlink: backlink } })
    ),
    on(GeneralMapActions.setupParcelList, (state, {mapId}): Record<string, IGeneralMapState> =>
        ({...state, [mapId]: {...state[mapId], detailFeature: INIT_STATE.detailFeature, backlink: false } })
    ),
    on(GeneralMapActions.resetState, (): Record<string, IGeneralMapState> => ({})),
)

export interface IGeneralMapState {
    backlink: boolean;
    pagePrintHeading: string;
    padding: number;
    detailFeature: any;
    currentFeatureInfo: CurrentFeatureInfoInterface;
    features: any[]; // must be array all the time!
    header: string;
    parcelToGroupDrawing: IMapStateParcelToGroupDrawing;
    measuredLength: number;
    measuredArea: number;
    measuredCoordinates: number;
    parcelListShowAddonInformation: boolean;
    layersConfig: any;
    layersOutsideSelector: any[]; // must be array all the time!
    parcelContractEndingDate: string;
    parcelContractEndingDateVisible: boolean;
    parcelContractEndingDateMinimalized: boolean;
    saveLayersVisibility: boolean;
    saveLayersVisibilityAfterInit: boolean;
    storagePrefix: string;
    zoomedId: IGeneralMapZoomedId;
    showedInfoBox: MapInfoBoxTypeEnum;
    showedLpisUserSelection: boolean;
    showedLpisEndingContract: boolean;
    showedParcelSelectByShapeDrawing: boolean;
    showedParcelSelectByAddArea: boolean;
    showedParcelSplitting: boolean;
    collapsed: boolean;
    lpisUserSelectionCollapsed: boolean;
    lpisEndingContractCollapsed: boolean;
    parcelSelectByShapeDrawingCollapsed: boolean;
    parcelSelectByAddAreaCollapsed: boolean;
    parcelSplittingCollapsed: boolean;
    showedLpisUserSelectionCollapsed: boolean;
}

export interface IGeneralMapZoomedId {
    layerName: string;
    featureId: string;
}